export default __webpack_public_path__ + "static/media/eye-icon.4018818b.svg";